module.exports = __webpack_public_path__ + "2b722a4897398b0d7c49e12a2a921a57.jpg";